/** @format */

export enum PzPinnedContentType {
  STANDARD = 'standard',
  BOPIS = 'bopis',
  DEAL_SEEKERS = 'dealSeekers',
}
